export default __webpack_public_path__ + "static/media/apkDownload.5c07ff58.svg";